<template>
    <div class="file-view">
        <MaterialResPlayer
            :material="props.fileData"
            :video-options="{ autoplay: false, controlBar: {pictureInPictureToggle: false}}"
            class="tpkcw-res"
            :width="playerConf.width"
            :height="playerConf.height"
            withFullScreen
            />
            <!-- :height="playerConf.height" -->
    </div>
</template>

<script setup>
import { MaterialResPlayer } from '@yanxiu/player';
import { reactive, computed } from 'vue';

const props = defineProps({
    fileData: {
        type: Object,
        default: () => {}
    }
})


// let playData = reactive({
//     resourceId: '4025798122146996225',
//     type: 'nolive',
//     name: '测试视频.flv',
//     filePath: 'https://srt-read-dev.3ren.cn/basebusiness/material/20200205/1580839788772L9BYz2GQrU001.flv',
//     previewUrl: 'https://srt-read-dev.3ren.cn/basebusiness/material/20200205/transcode/06010ac4-2f9c-4c0d-83fb-877151ce9553/6214097b-cc5a-483c-8185-167533f52163.m3u8',
//     fileNameExtension: 'flv',
//     liveState: undefined,
//     canDownload: 1
// })

const COURSE_WIDTH = 900;
const COURSE_HEIGHT = 598;

let playerConf = reactive({
    width: COURSE_WIDTH,
    height: COURSE_HEIGHT
})

const playData = computed(() => {
    let data = props.fileData || {};
    console.log(data);
    if(data.materialType !== 'video') {
        return {

            resourceId: data.materialId,
            name: data.materialName,
            filePath: data.materialUrl,
            previewUrl: data.previewUrl || data.materialUrl,
            fileNameExtension: data.materialNameSuffix,
            canDownload: data.isDownload 
            
        }; 
    }
    return {};                
})
</script>

<style scoped>
.file-view {
    width: 900px;
    margin: 0 auto;
}
</style>